import { useId } from "react";
import { useTranslation } from "react-i18next";
import { Box, List, ListItem, Typography } from "@mui/material";
import { v } from "../../utils/helpers";
import { stageLabel } from "../../utils/stages";

/** Wartende und laufende Pakete der Beförderung aus `board.capacity.queue`, in Reihenfolge (Vertrag 6.1, 13, 16.2). */
export default function StageQueue({ board, capacity }) {
  const { t } = useTranslation("freigabe");
  const titleId = useId();
  const queue = capacity?.queue || [];
  if (queue.length === 0) return null;
  const packageName = id => board?.packages?.find(pkg => pkg.packageId === id)?.packageName || id;
  const targetLabel = key => board?.stages?.find(stage => stage.key === key)?.label || stageLabel(key);
  // Mehrere Ziele je Stufe: targetId steht nur bei Zusatzzielen, fehlend ist das Standardziel. Der Name kommt aus den Zielen
  // der Stufe (auch außerhalb der gewählten Region).
  const targetName = entry => {
    if (entry.targetId == null) return null;
    const stage = board?.stages?.find(row => row.key === entry.targetStage);
    return (stage?.allTargets || stage?.targets || []).find(target => target.targetId === entry.targetId)?.instanceName || entry.targetId;
  };
  return <Box component="section" aria-labelledby={titleId}>
    <Typography component="h3" variant="subtitle2" id={titleId} sx={{ color: v("text-1"), mb: 1 }}>{t("stageBranches.queue.title")}</Typography>
    <List dense disablePadding aria-labelledby={titleId}>
      {queue.map(entry => <ListItem key={`${entry.requestId}:${entry.packageId}:${entry.targetStage}:${entry.targetId ?? "default"}`} disableGutters
        sx={{ gap: 1.5, flexWrap: "wrap", borderBottom: `1px solid ${v("border-subtle")}` }}>
        <Typography component="span" variant="body2" sx={{ color: v("text-1"), fontWeight: 600 }}>{packageName(entry.packageId)}</Typography>
        <Typography component="span" variant="body2" sx={{ color: v("text-2") }}>
          {targetName(entry)
            ? t("stageBranches.queue.targetNamed", { stage: targetLabel(entry.targetStage), name: targetName(entry) })
            : t("stageBranches.queue.target", { stage: targetLabel(entry.targetStage) })}
        </Typography>
        <Typography component="span" variant="body2" sx={{ color: v(entry.status === "running" ? "accent" : "text-3"), ml: "auto" }}>
          {t(`stageBranches.queue.${entry.status === "running" ? "running" : "waiting"}`)}
        </Typography>
      </ListItem>)}
    </List>
  </Box>;
}
